<template>
	<div class="full-width full-height">
		<apexcharts
			width="100%"
			:height="height"
			type="bar"
			:options="chartOptions"
			:series="processed_series"
		></apexcharts>
		<div class="text-left" style="margin-top: -30px; margin-left: 30px;">
			Timezone: UTC {{ timezone }}
		</div>
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
var moment = require("moment");
export default {
	components: {
		apexcharts: VueApexCharts
	},
	name: "Chart",
	props: ["series", "categories", "height", "portfolio_chart"],
	data: function() {
		let yaxis = null;

		if (this.portfolio_chart) {
			yaxis = {
				show: true,
				labels: {
					style: {
						color: "white",
						fontSize: "18px",
						fontFamily: "Helvetica, Arial, sans-serif"
					},
					formatter: value => {
						return value + " (MWh)";
					}
				}
			};
		} else {
			yaxis = [
				{
					seriesName: "temperature",
					show: false,
					labels: {
						formatter: value => {
							return value + "º";
						}
					}
				},
				{
					seriesName: "pv_power",
					show: true,
					labels: {
						style: {
							color: "white",
							fontSize: "18px",
							fontFamily: "Helvetica, Arial, sans-serif"
						},
						formatter: value => {
							return value + " (MWh)";
						}
					}
				}
			];
		}

		return {
			chartOptions: {
				chart: {
					id: "basic-bar",
					toolbar: { show: true, tools: { download: false } },
					zoom: {
						enabled: true
					}
				},
				legend: {
					position: "top",
					horizontalAlign: "center",
					fontSize: "18px",
					labels: {
						useSeriesColors: true
					}
				},
				xaxis: {
					type: "datetime",
					labels: {
						datetimeFormatter: {
							year: "yyyy",
							month: "MMM 'yy",
							day: "dd MMM",
							hour: "HH:mm"
						},
						style: {
							colors: "white",
							fontSize: "15px"
						}
					}
				},
				yaxis: yaxis,
				tooltip: {
					enabled: true,
					shared: true,
					followCursor: true,
					x: {
						format: "HH:mm d MMM"
					},
					theme: "dark",
					style: {
						fontSize: "18px"
					}
				},
				fill: {
					type: "solid",
					colors: this.portfolio_chart ? ["#00ff8a"] : ["#69c8de", "#00ff8a"],
					opacity: 0.7
				},
				stroke: {
					width: 3,
					curve: "straight"
				},
				tickAmount: "dataPoints",
				colors: this.portfolio_chart ? ["#00ff8a"] : ["#69c8de", "#00ff8a"],
				dataLabels: {
					enabled: false
				}
			}
		};
	},
	computed: {
		processed_series: function() {
			return format_time_serie(this.series);
		},
		timezone: function() {
			return moment().format("Z");
		}
	}
};

function format_time_serie(ts) {
	var cache_series = {};
	ts.forEach(function(ts_row) {
		for (var key in ts_row) {
			if (key == "time") continue;
			if (!cache_series[key]) {
				cache_series[key] = [];
			}
			cache_series[key].push([new Date(parseInt(ts_row.time)), ts_row[key]]);
		}
	});

	var return_series = [];

	for (var key in cache_series) {
		return_series.push({
			name: key == "temperature" ? "Temperature" : "PV power",
			data: cache_series[key],
			type: key == "temperature" ? "line" : "area"
		});
	}

	return return_series;
}
</script>

<style>
.apexcharts-menu-item {
	color: black;
}
</style>
